namespace $.$$ {

	$mol_style_define( $shm_ba_file_store_list, {
		display: 'grid',
		gap: '12px',
		alignItems: 'start',
		padding: {
			top: $mol_gap.block,
			bottom: $mol_gap.block,
		},

		Head: {
			display: 'flex',
			alignItems: 'center',
			gap: '12px',
			maxWidth: '720px',
		},

		Title: {
			font: {
				size: '18px',
				weight: 'bold',
			},
			flex: {
				grow: 1,
			},
		},

		Summary: {
			color: $mol_theme.shade,
			font: { size: '13px' },
		},

		Delete_all: {
			Trigger: {
				alignItems: 'center',
				gap: '6px',
			},
		},

		Delete_all_icon: {
			width: '16px',
			height: '16px',
		},

		Delete_all_confirm: {
			display: 'grid',
			gap: '12px',
			padding: $mol_gap.block,
			minWidth: '240px',
		},

		Delete_all_actions: {
			justifyContent: 'flex-end',
			gap: '8px',
		},

		Search: {
			maxWidth: '360px',
		},

		Files: {
			maxWidth: '720px',
			maxHeight: '360px',
			overflow: 'auto',
			border: {
				top: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		File_row: {
			display: 'grid',
			gridTemplateColumns: 'minmax(0, 1fr) 36px',
			alignItems: 'center',
			gap: '8px',
			padding: {
				top: '8px',
				bottom: '8px',
			},
			border: {
				bottom: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		File_info: {
			display: 'grid',
			minWidth: 0,
		},

		File_title: {
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},

		File_meta: {
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},

		File_delete: {
			flex: {
				grow: 0,
				shrink: 0,
			},
			Trigger: {
				alignItems: 'center',
				justifyContent: 'center',
				minWidth: '36px',
				minHeight: '36px',
				padding: 0,
			},
		},

		File_delete_icon: {
			width: '16px',
			height: '16px',
		},

		File_delete_bubble: {
			flexDirection: 'column',
			gap: 0,
			padding: 0,
		},

		File_delete_text: {
			alignItems: 'center',
			minHeight: '32px',
			padding: {
				left: '12px',
				right: '12px',
			},
		},

		File_delete_yes: {
			minHeight: '32px',
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
				top: 0,
				bottom: 0,
			},
		},

		File_delete_no: {
			minHeight: '32px',
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
				top: 0,
				bottom: 0,
			},
		},

		Empty: {
			color: $mol_theme.shade,
			padding: {
				top: '12px',
				bottom: '12px',
			},
		},
	} )

}
